import React from 'react';

import { AcademyIaToolbar, AcademyIaList } from 'views/AcademyIa/components';
import { useStyles } from './styles';

export default () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AcademyIaToolbar />
      <div className={classes.content}>
        <AcademyIaList />
      </div>
    </div>
  );
};
